import { Cta } from "@/components/cta"
import { client } from "@/root/contents/sanity/lib/client"
import { cn } from "@/utils/cn"
import { useNextSanityImage } from "next-sanity-image"
import { SanityImageAsset, SanityReference } from "sanity-codegen"

const socialIconColors = {
  white: "text-neutral-light",
  blue: "text-primary-800",
} as const

type SocialIconColor = keyof typeof socialIconColors

export function SocialIconLink({
  asset,
  url,
  color,
  className,
  title = "social icon",
}: {
  asset: SanityReference<SanityImageAsset>
  url: string
  color: SocialIconColor
  className?: string
  title?: string
}) {
  const imageProps = useNextSanityImage(client, asset)

  return (
    <Cta
      variant="blank"
      className={cn("inline-flex h-8 w-8 items-center justify-center", socialIconColors[color], className)}
      sanity={{
        type: "external",
        linkTarget: "_blank",
        externalLink: url,
      }}
      aria-label={title}
    >
      <span
        className="block h-full w-full"
        style={{
          backgroundColor: "currentColor",
          maskImage: `url(${imageProps.src})`,
          WebkitMaskImage: `url(${imageProps.src})`,
          maskRepeat: "no-repeat",
          WebkitMaskRepeat: "no-repeat",
          maskPosition: "center",
          WebkitMaskPosition: "center",
          maskSize: "contain",
          WebkitMaskSize: "contain",
        }}
      />
    </Cta>
  )
}
